import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import CreatorDisplayOrder from '@/components/creator_display_order.vue'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['order']
  connect() {
    const app = createApp(CreatorDisplayOrder, {
      department: JSON.parse(this.element.dataset.department),
      creators: JSON.parse(this.element.dataset.creators)
    })
    app.use(PrimeVue)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.orderTarget)
  }
}
